import {frontend} from 'pageflow-scrolled/frontend';

import {PricingTable} from './PricingTable';

frontend.contentElementTypes.register('pricingTable', {
  component: PricingTable,
  lifecycle: true
});
